import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { VISION_BANNER } from "../data/content";

export const VisionBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="vision-banner" className="relative h-[70vh] min-h-[480px] overflow-hidden flex items-center">
      <motion.img
        src={VISION_BANNER.image}
        alt={VISION_BANNER.alt}
        loading="lazy"
        style={{ y }}
        className="absolute inset-0 w-full h-[124%] object-cover -top-[12%]"
      />
      <div className="absolute inset-0 bg-royal-deep/70" aria-hidden="true" />
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 text-center">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="block text-xs tracking-[0.35em] uppercase text-gold font-medium mb-6"
        >
          Our Vision
        </motion.span>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ivory leading-[1.08] tracking-tight">
          {["Building Trust,", "One Precious Moment at a Time"].map((line, i) => (
            <motion.span
              key={line}
              className="block overflow-hidden pb-1"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.4 }}
            >
              <motion.span
                className={`block ${i === 1 ? "italic text-gold-light" : ""}`}
                variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
                transition={{ duration: 1, delay: 0.15 * i, ease: [0.22, 1, 0.36, 1] }}
              >
                {line}
              </motion.span>
            </motion.span>
          ))}
        </h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-7 text-base md:text-lg font-light text-ivory/75 max-w-2xl mx-auto leading-relaxed"
        >
          {VISION_BANNER.text}
        </motion.p>
      </div>
    </section>
  );
};
